var _defs, _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #01bff9;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 212.1724278027,
    y1: 75.714320709,
    x2: 335.3921566521,
    y2: 411.256710856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01c0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004281"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 256,
    cy: 199.5378050268,
    r: 132.1232817277
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 199.5378050268,
    r: 95.9269662974
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m256.0000305176,42.2343978882c-86.8762817383,0-157.3034057617,70.4271240234-157.3034057617,157.3034057617,0,73.1922607422,111.6520385742,220.5416870117,146.8248901367,265.1441040039,5.3452758789,6.7782592773,15.6117553711,6.7782592773,20.95703125,0,35.1727905273-44.6024169922,146.8248291016-191.9518432617,146.8248291016-265.1441040039,0-86.8762817383-70.4271240234-157.3034057617-157.3033447266-157.3034057617Zm0,277.3876342773c-66.3207397461,0-120.0842895508-53.7635498047-120.0842895508-120.0842285156,0-66.3207397461,53.7635498047-120.0842895508,120.0842895508-120.0842895508,66.3206787109,0,120.0842285156,53.7635498047,120.0842285156,120.0842895508,0,66.3206787109-53.7635498047,120.0842285156-120.0842285156,120.0842285156Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m324.8336967998,181.5527761495l-64.6202693525-51.4278960245c-2.4661179868-1.9626544532-5.9607369078-1.9626544532-8.4268548946,0l-64.6202693525,51.4278960245c-.3706418193.2949744583-.586591339.7428284577-.586591339,1.2165217015v8.4382964839c0,3.3497554974,2.7155133669,6.0652688643,6.0652688643,6.0652688643h10.5091251896v54.1970645632c0,3.830660058,3.1053635406,6.9360235986,6.9360235986,6.9360235986h22.1209262099c3.830660058,0,6.9360235986-3.1053635406,6.9360235986-6.9360235986v-28.7349549087c0-5.6382009512,4.5706649516-10.2088659028,10.2088659028-10.2088659028h12.5291657071c5.6382009512,0,10.2088659028,4.5706649516,10.2088659028,10.2088659028v28.7349549087c0,3.830660058,3.1053635406,6.9360235986,6.9360235986,6.9360235986h22.8798700527c3.830660058,0,6.9360235986-3.1053635406,6.9360235986-6.9360235986v-54.1970645632h10.5091251896c3.3497554974,0,6.0652688643-2.7155133669,6.0652688643-6.0652688643v-8.4382964839c0-.4736932438-.2159495198-.9215472432-.586591339-1.2165217015Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6f3b4d4ef9d4e2dab63a152c91f612bd.svg";
export { ForwardRef as ReactComponent };